<template>
    <div>
        <div class="row">
            <div class="col-md-9">
                <input class="form-control acInput" type="text"
                       placeholder="ID Agencia o Nombre"
                       id="entity"
                       name="entity"
                       v-model="data.id">
            </div>
            <div class="col-md-2">
                <button type="submit" class="btn btn-primary"
                        @click="onSearchByAgenciId">
                    Buscar
                </button>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapState, mapMutations, mapGetters } from "vuex"

    export default {
        name: "AgencyIdInput",

        components: {
        },

        data(){
            return {
                errorCode: 0,
                errorTxt: null,
                context: 'DirectProductConfig/DirectProductController/',
                data: {
                    id: null,
                    name: null,
                    exclusiveRates: null,
                    exclusiveDiscounts: null
                },
                lastAgencyId: null
            }
        },
        computed: {
            ...mapState(['errorMessage']),
            ...mapState('DirectProduct',['storeAgency','storeHotel']),
            ...mapGetters('DirectProduct',['getHasModified']),
        },
        methods: {
            ...mapMutations(['hideMessageError','visibleMessageError']),
            ...mapMutations('DirectProduct',['fillAgencyData','fillHotelData','fillHasModified']),

            onSearchByAgenciId() {
                if (this.getHasModified != '') {
                    this.fillHasModified({ "data": "modal", "value": 1});
                } else {
                    this.fillHotelData({
                        id: 0,
                        name: null
                    },);
                    this.searchAgency();
                }
            },
            searchAgency() {
                this.errorCode = 0;
                this.errorTxt = null;
                return new Promise((resolve,reject) => {
                    this.lastAgencyId = this.data.id;
                    /*
                    // -------------- ESCENARIO 1 --------------
                    // LOCAL (app independiente, file en carpeta public)
                    this.$http.get('bdDataFake.json').then(({data}) => {
                        let agency = data.bd.AgencyById.data
                            .filter(e => e.id === this.data.id)
                        if (agency.length === 0) {
                            data.result = false
                        } else {
                            data.result = true;
                            data.data = agency[0];
                        }
                        // fin LOCAL

                    // -------------- ESCENARIO 2 --------------
                    // REAL
                    this.$http.get(this.context + 'getAgencyById', {
                        params: {
                            agencyId: this.data.id,
                        }
                    }).then(({data}) => {
                        // Fin REAL
                    */
                    // REAL
                    this.$http.get(this.context + 'getAgencyById', {
                        params: {
                            agencyId: this.data.id,
                        }
                    }).then(({data}) => {
                        // Fin REAL
                        let listData = data.data;
                        this.data.id = listData.id;
                        this.data.name = listData.name;
                        this.data.exclusiveRates = listData.exclusive_rates;
                        this.data.exclusiveDiscounts = listData.exclusive_discounts;
                        if (this.errorMessage != '') {
                            this.hideMessageError()
                        }
                        resolve(true);
                    }).catch( error => {
                        this.data.id = null;
                        this.data.name = null;
                        reject(error);
                    }).finally((data) => {
                        this.fillAgencyData(this.data);
                    });
                }).catch((error) => {
                    this.errorCode = error.error_code;
                    this.errorTxt = error.error_message;
                    this.scrollToTop();
                });
            },
            scrollToTop() {
                window.scrollTo(0,0);
            },
        },
        watch: {
            errorCode () {
                if(this.errorCode !== 0) {
                    this.visibleMessageError(this.errorTxt,0);
                }
            },
        },
    }

</script>

<style scoped>
    .acInput {
        padding: 6px 12px;
        color: #555;
        border-radius: 4px;
        border: 1px solid #ccc;
    }

    h1 {
        margin-top: 5px;
        margin-bottom: 10px;
    }
</style>    